export default {
  A4_Vertical: 'CDT_F03C_01',
  A4_Horizontal: 'CDT_F03C_02',
};
